import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import { CssBaseline } from '@mui/material'
import { SnackbarProvider } from 'notistack'
import { QueryClient, QueryClientProvider } from 'react-query'
import { Provider } from 'react-redux'

import App from './App'
import { store } from './store'

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#0F2A4E',
      dark: '#0A1E3A',
      light: '#2D72C9',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#2D72C9',
      light: '#4A9EFF',
      contrastText: '#ffffff',
    },
    background: {
      default: '#FAFAF7',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#12161E',
      secondary: '#4A5364',
    },
    divider: '#D8D4C7',
  },
  typography: {
    fontFamily: '"Archivo", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    h1: { fontWeight: 900, letterSpacing: '-0.01em' },
    h2: { fontWeight: 900, letterSpacing: '-0.01em' },
    h3: { fontWeight: 800, letterSpacing: '-0.005em' },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
    button: { fontWeight: 700, letterSpacing: '0.02em', textTransform: 'none' },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        code: { fontFamily: '"JetBrains Mono", "SF Mono", Consolas, monospace' },
        pre: { fontFamily: '"JetBrains Mono", "SF Mono", Consolas, monospace' },
      },
    },
  },
})

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <SnackbarProvider 
              maxSnack={3}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              <App />
            </SnackbarProvider>
          </ThemeProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>,
)